import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { StoryblokImage } from "@wojo/storyblok";
import { Button, Card, Text } from "@wojo/ui";
import React, { useId, useState } from "react";
import { PricedExcursionFragment } from "../../../generated/graphql";
import { getCurrency } from "../../../hooks";
import styles from "./Itinerary.module.scss";
import { ItineraryExcursionModal } from "./ItineraryExcursionModal";

type ItineraryExcursionProps = {
    excursion: PricedExcursionFragment;
};

export const ItineraryExcursion: React.FC<ItineraryExcursionProps> = ({
    excursion,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const titleId = useId();
    const descriptionId = useId();
    const { productPage } = useI18n("productPage");
    const { formattedPrice } = getCurrency();
    const { image, name, duration, departureInfo, description, lowestPrice } =
        excursion;

    // TODO: https://ef-wojo.atlassian.net/browse/WWR-563 replace this with info from the graph
    const dpdDeadline = "70";

    return (
        <>
            <Card
                tag="button"
                className={styles.excursion}
                type="button"
                aria-labelledby={name ? titleId : undefined}
                aria-describedby={descriptionId}
                onClick={() => {
                    gtmSendEvent({
                        event: "track",
                        ga4Tracking: {
                            ga4_action: "OPENED",
                            ga4_object: "MODAL",
                            modalId: "TourExcursion",
                            excursionName: name ?? "",
                        },
                    });
                    setIsModalOpen(true);
                }}
            >
                {!!image?.filename && (
                    <div className={styles["excursion-image-container"]}>
                        <StoryblokImage
                            className={styles["excursion-image"]}
                            mobile={{
                                asset: image,
                                size: {
                                    width: 690,
                                },
                            }}
                            desktop={{
                                asset: image,
                                size: {
                                    width: 494,
                                },
                            }}
                        />
                    </div>
                )}
                <div
                    style={{
                        padding: "var(--g-spacing-md)",
                        textAlign: "left",
                        width: "60%",
                    }}
                >
                    <Text.Body
                        emphasis="2"
                        id={titleId}
                        style={{ marginBottom: "var(--g-spacing-xs)" }}
                    >
                        {name}
                    </Text.Body>
                    {lowestPrice && (
                        <Text.Body id={descriptionId}>
                            {productPage.itinerary.day.excursion.price.l({
                                price: formattedPrice([lowestPrice]),
                            })}
                        </Text.Body>
                    )}
                    <Button
                        variant="quiet"
                        tag="span"
                        style={{ marginTop: "var(--g-spacing-xl)" }}
                    >
                        {productPage.itinerary.day.excursion.modalTrigger.l()}
                    </Button>
                </div>
            </Card>
            <ItineraryExcursionModal
                accessibleTitle={productPage.itinerary.day.excursion.modalAccessibleLabel.l(
                    { excursionName: name || "" },
                )}
                isOpen={isModalOpen}
                onCloseRequested={() => setIsModalOpen(false)}
                name={name ?? undefined}
                image={image ?? undefined}
                price={lowestPrice && formattedPrice([lowestPrice])}
                duration={duration ?? undefined}
                departureInfo={departureInfo ?? undefined}
                description={description ?? undefined}
                dpdDeadline={dpdDeadline}
            />
        </>
    );
};
